// Who gets Owner reports: admins of BoomCRM partners whose plan includes them.
// Admin-only because a report emails partner analytics to people outside the
// account; the `owner_reports` entitlement is Pro-only, so BoomScreen-only and
// Core partners don't see the section (CRM-1671). Mirrors the owner-reports
// API gate. Shared by the routes and the nav link so they never disagree.
export const canViewOwnerReports = (type: {
  isBoomCRM: boolean;
  isOwnerReports: boolean;
  adminPrivileges: boolean;
}): boolean => type.isBoomCRM && type.isOwnerReports && type.adminPrivileges;
